import { type Context, createContext, type Provider, useContext } from 'react';

type AgentOverriderContext = {
	agentDefaultIdOverride?: string;
	agentIdFiltersOverride?: string[];
};

export interface AgentsConfig {
	/**
	 * filter agents based on the agent id that are available to the user.
	 */
	filter?: string[];
	/**
	 * default agent id to be selected.
	 */
	defaultAgentId?: string;
}

export const agentOverrider: Context<AgentOverriderContext> = createContext<AgentOverriderContext>(
	{},
);
export const useAgentOverrider = (): AgentOverriderContext => useContext(agentOverrider);
export const AgentOverriderProvider: Provider<AgentOverriderContext> = agentOverrider.Provider;

export const createAgentsConfig = (config?: Partial<AgentsConfig>): AgentOverriderContext => ({
	agentDefaultIdOverride: config?.defaultAgentId,
	agentIdFiltersOverride: config?.filter,
});
